import React from "react";
import ReactPaginate from 'react-paginate';
import {encode as base64_encode} from 'base-64';
import { ReactSession } from 'react-client-session';

import { Helpers } from "../../config/Helpers";
import {toast} from "react-toastify";
import {Button, Modal, ModalBody, ModalFooter} from "reactstrap";

class Chat extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            offset: 0,
            perPage: 10,
            currentPage: 0,
            pageNumList: [10,25,50,100,150,200],
            sortData: ['Featured','ID Ascending','ID Descending'],
            search: '',
            isModalOpen: false,
            questionData: ['Akun Saya','Pesanan Saya','Pembayaran','Pengiriman','Lainnya'],
            questionType: '',
            question: ''
        };
        this.handlePageClick = this.handlePageClick.bind(this);
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            this.getKomplain();
        }
    }

    getKomplain = () => {
        Helpers.getKomplain(this.state.sessUserCode).then(res => {
            let sortData = res;
            if(this.state.search !== ''){
                sortData = sortData.filter(item => {
                    const textData = this.state.search.toUpperCase();

                    return Object.keys(item).some(key => ((item[key]) ? item[key] : '').toString().toUpperCase().search(textData) !== -1);
                });
            }
            if(this.state.sortDataValue == 'ID Descending'){
                sortData = sortData.sort(function(a,b) {
                    const val_a = a.KodeKomplain.toUpperCase();
                    const val_b = b.KodeKomplain.toUpperCase();

                    return (val_a < val_b) ? 1 : ((val_b < val_a) ? -1 : 0);
                });
            }
            if(this.state.sortDataValue == 'ID Ascending'){
                sortData = sortData.sort(function(a,b) {
                    const val_a = a.KodeKomplain.toUpperCase();
                    const val_b = b.KodeKomplain.toUpperCase();

                    return (val_a > val_b) ? 1 : ((val_b > val_a) ? -1 : 0);
                });
            }

            const slice = sortData.slice(this.state.offset, this.state.offset + this.state.perPage)
            const postData = slice.map((object, i) => {
                return <div className="col-lg-3 col-md-6 col-12 col-sm-6">
                    <div className="vendor-wrap mb-40">
                        <div className="vendor-img-action-wrap" style={{'padding': 'unset'}}>
                            <div className="vendor-img">
                                <table style={{'margin-bottom': 'unset'}}>
                                    <tr>
                                        <td>
                                            <div className="d-flex justify-content-between align-items-end">
                                                <div>
                                                    <h4 style={{'font-size': '15px'}}><a style={{'color': '#000'}}>{object.KodeKomplain}</a></h4>
                                                    <p className="mt-2" style={{'font-size': '13px', 'line-height': '1.5'}} align="justify">
                                                        {object.CreatedOn} <br/>
                                                        Jenis Bantuan: {object.Jenis} <br/>
                                                        {object.LastChat}
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div className="product-badges product-badges-position product-badges-mrg">
                                <span className="hot">
                                    <a>{object.Status}</a>
                                </span>
                            </div>
                        </div>
                        <div className="vendor-content-wrap" style={{'padding': '10px 20px 10px 20px'}}>
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <a href={'./chat-details?trxid=' + base64_encode(object.KodeKomplain)} className="btn btn-xs">Detail Percakapan <i className="fi-rs-arrow-small-right"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            })

            this.setState({
                pageCount: Math.ceil(sortData.length / this.state.perPage),
                postData
            })
        })
    };

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage * this.state.perPage;

        this.setState({
            currentPage: selectedPage,
            offset: offset
        }, () => {
            this.getKomplain()
        });

    };

    handlePageNumClick = (num) => {
        this.setState({
            currentPage: 0,
            offset: 0,
            perPage: num,
        }, () => {
            this.getKomplain()
        });
    };

    handleSortByClick = (sortBy) => {
        this.setState({
            currentPage: 0,
            offset: 0,
            sortDataValue: sortBy
        }, () => {
            this.getKomplain()
        });
    };

    handleSearch = (e) => {
        e.preventDefault();

        this.setState({
            currentPage: 0,
            offset: 0
        }, () => {
            this.getKomplain()
        });
    };

    handleModal = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    handleSubmit = () => {
        if(this.state.questionType && this.state.question){
            Helpers.createKomplain(
                '',
                this.state.sessUserCode,
                'Admin',
                this.state.questionType,
                this.state.question,
                'new'
            ).then(res => {
                if(res.length > 0){
                    if(res[0].alert == 'success'){
                        setTimeout(function() {
                            window.location.href = './chat-details?trxid=' + base64_encode(res[0].KodeKomplain);
                        }, 1000);
                    }

                    toast[res[0].alert](res[0].message);
                }else{
                    toast.error(Helpers.MSG_ERROR);
                }
            })
        }else{
            toast.error(Helpers.MSG_ERROR_FORM);
        }
    };

    render() {
        return (
            <>
                <Modal
                    size={'lg'}
                    isOpen={this.state.isModalOpen}
                    toggle={() => {this.handleModal()}}>
                    <ModalBody style={{'padding': 'unset'}}>
                        <div className="row mt-15" style={{'margin': 'unset'}}>
                            <div className="col-lg-12">
                                <div className="input-style mb-20">
                                    <label>Jenis Pertanyaan</label>
                                    <div className="custom_select">
                                        <select
                                            className="select-style" required onChange={e => this.setState({questionType: e.target.selectedOptions[0].text})}>
                                            <option value={''}>Pilih Jenis Pertanyaan</option>
                                            {
                                                this.state.questionData.map((object, i) => {
                                                    return <option value={i}>{object}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="input-style mb-20">
                                    <label>Pertanyaan</label>
                                    <textarea value={this.state.question} onChange={e => this.setState({question: e.target.value})}
                                              placeholder="Masukkan pertanyaan anda"
                                              required />
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="primary"
                            onClick={() => {this.handleSubmit()}}>
                            Kirim
                        </Button>
                        {' '}
                        <Button onClick={() => {this.handleModal()}}>
                            Close
                        </Button>
                    </ModalFooter>
                </Modal>
                <main className="main pages mb-80">
                    <div className="page-header breadcrumb-wrap">
                        <div className="container">
                            <div className="breadcrumb">
                                <a href="./" rel="nofollow"><i className="fi-rs-home mr-5"></i>Beranda</a>
                                <span></span> Chat
                            </div>
                        </div>
                    </div>
                    <div className="page-content pt-20">
                        <div className="container">
                            <div className="archive-header-2 text-center">
                                <div className="row">
                                    <div className="col-lg-5 mx-auto">
                                        <div className="sidebar-widget-2 widget_search mb-50">
                                            <div className="search-form">
                                                <form method="post" onSubmit={(e) => {this.handleSearch(e)}}>
                                                    <input type="text" placeholder="Cari pesan bantuan ..." value={this.state.search} onChange={e => this.setState({search: e.target.value})}/>
                                                    <button type="submit"><i className="fi-rs-search"></i></button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 col-lg-8 mx-auto">
                                    <div className="shop-product-fillter">
                                        <div className="totall-product">
                                            <a onClick={() => {this.handleModal()}} className="btn btn-sm">Buat Pertanyaan Baru</a>
                                        </div>
                                        <div className="sort-by-product-area">
                                            <div className="sort-by-cover mr-10">
                                                <div className="sort-by-product-wrap">
                                                    <div className="sort-by">
                                                        <span><i className="fi-rs-apps"></i>Show:</span>
                                                    </div>
                                                    <div className="sort-by-dropdown-wrap">
                                                        <span> {this.state.perPage} <i className="fi-rs-angle-small-down"></i></span>
                                                    </div>
                                                </div>
                                                <div className="sort-by-dropdown">
                                                    <ul>
                                                        {
                                                            this.state.pageNumList.map((object, i) => {
                                                                return <li><a className={(object == this.state.perPage) ? 'active': ''} onClick={() => {this.handlePageNumClick(object)}}>{object}</a></li>
                                                            })
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="sort-by-cover">
                                                <div className="sort-by-product-wrap">
                                                    <div className="sort-by">
                                                        <span><i className="fi-rs-apps-sort"></i>Sort by:</span>
                                                    </div>
                                                    <div className="sort-by-dropdown-wrap">
                                                        <span> Featured <i className="fi-rs-angle-small-down"></i></span>
                                                    </div>
                                                </div>
                                                <div className="sort-by-dropdown">
                                                    <ul>
                                                        {
                                                            this.state.sortData.map((object, i) => {
                                                                return <li><a className={(object == this.state.sortDataValue) ? 'active': ''} onClick={() => {this.handleSortByClick(object)}}>{object}</a></li>
                                                            })
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row vendor-grid">
                                {this.state.postData}
                            </div>

                            <div className="pagination-area mt-20 mb-20">
                                <nav aria-label="Page navigation example">
                                    <ReactPaginate
                                        previousLabel={<i className="fi-rs-arrow-small-left"></i>}
                                        previousClassName={"page-item"}
                                        previousLinkClassName={"page-link"}
                                        nextLabel={<i className="fi-rs-arrow-small-right"></i>}
                                        nextClassName={"page-item"}
                                        nextLinkClassName={"page-link"}
                                        breakLabel={"..."}
                                        breakClassName={"page-link dot"}
                                        pageCount={this.state.pageCount}
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={1}
                                        onPageChange={this.handlePageClick}
                                        containerClassName={"pagination justify-content-start"}
                                        activeClassName={"page-item active"}
                                        activeLinkClassName={"page-link"}
                                        pageClassName={"page-item"}
                                        pageLinkClassName={"page-link"}/>
                                </nav>
                            </div>
                        </div>
                    </div>
                </main>
            </>
        );
    }
}

export default Chat;